import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";

function SimpleDialog(props) {
  const { onClose, onlyClose, ...other } = props;

  function handleClose() {
    onlyClose();
  }

  function handleListItemClick(value) {
    onClose(value);
  }

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      {...other}
    >
      <DialogTitle id="simple-dialog-title">Type of Report</DialogTitle>
      <List>
        <ListItem button onClick={() => handleListItemClick("detailed")}>
          <ListItemText primary="Detailed " />
        </ListItem>
        <ListItem button onClick={() => handleListItemClick("brief")}>
          <ListItemText primary="Brief" />
        </ListItem>
      </List>
    </Dialog>
  );
}

function SelectReportType(props) {
  const { setClose, setSelectedValue, open } = props; 

  const handleClose = value => {
    setClose();
    setSelectedValue(value);
  };

  return (
    <div>
      <SimpleDialog
        open={open}
        onClose={handleClose}
        onlyClose={setClose}
      />
    </div>
  );
}

export default SelectReportType;
